"use client";

import { useRef } from "react";
import { Checkbox } from "./Checkbox";

type ListType = "bullet" | "number" | "todo";

interface ListMarkerProps {
  type: ListType;
  /** For numbered lists */
  number?: number;
  /** For todo lists */
  checked?: boolean;
  /** For todo lists */
  onToggle?: () => void;
  /** Is content empty */
  empty?: boolean;
  /** Indentation level (0-based) */
  indent?: number;
  className?: string;
}

// 들여쓰기 레벨별 bullet 스타일 - CSS 변수 사용
const bulletStyles = [
  "bg-[var(--color-text-secondary)]",
  "border border-[var(--color-text-muted)] bg-transparent",
  "bg-[var(--color-text-muted)]",
];

export function ListMarker({
  type,
  number = 1,
  checked = false,
  onToggle,
  empty = false,
  indent = 0,
  className = "",
}: ListMarkerProps) {
  const checkboxRef = useRef<HTMLInputElement>(null);

  if (type === "bullet") {
    const bulletStyle = bulletStyles[indent % bulletStyles.length];
    return (
      <span
        className={`
          w-1.5 h-1.5 rounded-full flex-shrink-0
          ${empty ? "bg-[var(--color-border)]" : bulletStyle}
          ${className}
        `}
      />
    );
  }

  if (type === "number") {
    return (
      <span
        className={`
          min-w-[1.5em] text-right flex-shrink-0 tabular-nums leading-[1.5]
          ${empty ? "text-[var(--color-text-muted)]" : "text-[var(--color-text-secondary)]"}
          ${className}
        `}
      >
        {number}.
      </span>
    );
  }

  // Todo checkbox - Checkbox Atom 재사용
  return (
    <Checkbox
      ref={checkboxRef}
      size="sm"
      checked={checked}
      onChange={onToggle}
      className={`flex-shrink-0 ${className}`}
    />
  );
}

export { type ListMarkerProps, type ListType };
